import React from 'react';
import { Title } from '../components/ui/Title';
import webmanzLogoImage from '../assets/webmanz-logo.png';

function Imprint() {
  return (
    <div className="container mx-auto px-6 py-8 md:py-24">
      <Title>Imprint</Title>
      
      <div className="max-w-3xl mx-auto panel">        
        <div className="space-y-6 text-light/80">
          
          <div className="md:col-span-2 flex flex-row gap-6 items-center">
            <div>
              <img width="120" height="120" src={webmanzLogoImage}  loading="lazy" />
            </div>
            <div>
              Kevin Manz<br />
              Bernstrasse 99<br />
              3086 Englisberg<br />
              <a className="underlined" href="mailto:info@webmanz.ch">info@webmanz.ch</a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mt-8 mb-4">Copyright</h3>
            <p>
              All content on this website, including text, images, graphics, and design, is protected by copyright. Unless otherwise stated, the rights are owned by the website operator. Any reproduction, distribution, or use outside the limits of copyright law requires prior written permission.
            </p>
          </div>

           <div>
            <h3 className="text-xl font-semibold mt-8 mb-4">Disclaimer</h3>
            <p>
              The content of this website has been created with the utmost care. However, we do not guarantee the accuracy, completeness, or timeliness of the information provided. The use of the website and its content is at your own risk.
            </p>
            <p className="mt-4">
              We are not liable for any damages resulting from the use of this website. This also applies to external links: although we carefully check linked content, we are not responsible for the content of external websites. The operators of the linked sites are solely responsible for their content.
            </p>
             <p className="mt-4">
              We reserve the right to modify or discontinue parts of the site or the entire offering without prior notice.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Imprint;